// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4490d001","455":"176bfe47","488":"d1ed4e7b","977":"437d02d3"}[chunkId] + ".chunk.js";
};